import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { DatePicker, Radio, Select, Button, Input, Switch, Icon } from 'antd';

import { isImageExist } from '../../data/config/utils';

const { RangePicker } = DatePicker;
const Option = Select.Option;
const Search = Input.Search;

class CustomHeader extends React.PureComponent {
  renderGranularityIcon = item => {
    const { granularity_value } = this.props;
    const active = granularity_value === item.value;
    if (item && isImageExist(item.icon) && isImageExist(item.icon)) {
      return (
        <Fragment>
          <img className={classNames("ori-r-pad-5", { "ori-display-none": !active })} src={item.activeIcon} height={10} />
          <img className={classNames("ori-r-pad-5", { "ori-display-none": active })} src={item.icon} height={10} />
        </Fragment>
      );
    }
  };

  render() {
    const { container_class, left_wrapper_class, right_wrapper_class, title_container_class, title_class, title, bottom_bordered, bottom_border_light, renderTitleIcon, show_date_range, date_range_props, date_range_disabled, date_range, onChangeDateRange, show_granularity, granularity_container_class, granularity_btn_style, granularity_value, granularity_disabled, onChangeGranularity, granularity_options, show_dropdown, dropdown_match_select_width, dropdown_value, dropdown_options, dropdown_disabled, onChangeDropdown, show_first_button, first_button_type, first_button_loading, first_button_class, onClickFirstButton, first_button_text, show_second_button, second_button_type, second_button_loading, second_button_class, onClickSecondButton, second_button_text, show_search, search_placeholder, onChangeSearch, onSearch, search_disabled, show_switch, switch_class, switch_checked, switch_disabled, switch_text_class, switch_text, onChangeSwitch, show_sync, sync_spin, onClickSync } = this.props; return (
      <div className={classNames(`ori-t-pad-15 ori-b-pad-5 ori-flex-row ori-flex-jsb ori-flex-wrap ${container_class}`, { "ori-b-border-default": bottom_bordered, "ori-b-border-light": bottom_border_light })} >
        <div className={left_wrapper_class}>
          {
            title &&
            <div className={`ori-b-mrgn-10 ${title_container_class}`}>
              {renderTitleIcon && renderTitleIcon()}
              <span className={`ori-capitalize ${title_class}`}>{title}</span>
            </div>
          }
          {
            show_granularity &&
            <div className="ori-b-mrgn-10">
              <Radio.Group buttonStyle={granularity_btn_style} disabled={granularity_disabled} size="small" className={granularity_container_class} value={granularity_value} onChange={onChangeGranularity}>
                {
                  granularity_options.map((item, index) => {
                    return (
                      <Radio.Button key={index} value={item.value} disabled={item.disabled}>
                        {this.renderGranularityIcon(item)}
                        <span>{item.name}</span>
                      </Radio.Button>
                    );
                  })
                }
              </Radio.Group>
            </div>
          }
          {
            show_sync &&
            <div className="ori-b-mrgn-10 ori-lr-pad-5 ori-flex-column ori-flex-jc ori-cursor-ptr" onClick={onClickSync}>
              <span><Icon type="sync" className="ori-font-md ori-font-primary" spin={sync_spin} />
                <span className="ori-font-sm ori-l-pad-5">Sync</span></span>
            </div>
          }
        </div>
        <div className={right_wrapper_class}>
          {
            show_switch &&
            <div className="ori-b-mrgn-10 ori-flex-column ori-flex-jc">
              <div className="ori-lr-pad-5">
                <Switch size="small" className={switch_class} disabled={switch_disabled} checked={switch_checked} onChange={onChangeSwitch} />
                {
                  switch_text &&
                  <span className={`ori-capitalize-first ori-lr-pad-5 ${switch_text_class}`}>{switch_text}</span>
                }
              </div>
            </div>
          }
          {
            show_search &&
            <div className="ori-lr-pad-5 ori-b-mrgn-10 ori-flex-column ori-flex-jc">
              <Search size='small' className="ori-input-search-box" placeholder={search_placeholder} onChange={onChangeSearch} onSearch={onSearch} disabled={search_disabled} />
            </div>
          }
          {
            show_date_range &&
            <div className="ori-lr-pad-5 ori-b-mrgn-10 ori-flex-column ori-flex-jc">
              <RangePicker size="small" className="ori-range-picker-default" format="DD-MM-YYYY" value={date_range} placeholder={['Start date', 'End date']} disabled={date_range_disabled} onChange={onChangeDateRange} {...date_range_props} />
            </div>
          }
          {
            show_dropdown &&
            <div className="ori-lr-pad-5 ori-b-mrgn-10">
              <Select size="small" className="ori-select ori-font-xs" dropdownMatchSelectWidth={dropdown_match_select_width} value={dropdown_value} disabled={dropdown_disabled} onChange={onChangeDropdown}>
                {
                  dropdown_options.map((item, index) => {
                    return (
                      <Option key={index} className="ori-font-xs" value={item.value}>{item.name}</Option>
                    );
                  })
                }
              </Select>
            </div>
          }
          {
            show_first_button &&
            <div className="ori-lr-pad-5 ori-b-mrgn-10 ori-flex-column ori-flex-jc">
              <Button type={first_button_type} size='small' loading={first_button_loading} className={first_button_class} onClick={onClickFirstButton}>{first_button_text}</Button>
            </div>
          }
          {
            show_second_button &&
            <div className="ori-lr-pad-5 ori-b-mrgn-10 ori-flex-column ori-flex-jc">
              <Button type={second_button_type} size='small' loading={second_button_loading} className={second_button_class} onClick={onClickSecondButton}>{second_button_text}</Button>
            </div>
          }
        </div>
      </div>
    );
  }
}

CustomHeader.propTypes = {
  container_class: PropTypes.string,
  left_wrapper_class: PropTypes.string,
  right_wrapper_class: PropTypes.string,
  title_container_class: PropTypes.string,
  title_class: PropTypes.string,
  title: PropTypes.string,
  bottom_bordered: PropTypes.bool,
  bottom_border_light: PropTypes.bool,
  renderTitleIcon: PropTypes.func,
  show_date_range: PropTypes.bool,
  date_range_props: PropTypes.object,
  date_range: PropTypes.array,
  date_range_disabled: PropTypes.bool,
  onChangeDateRange: PropTypes.func,
  show_granularity: PropTypes.bool,
  granularity_container_class: PropTypes.string,
  granularity_btn_style: PropTypes.oneOf(["solid", "outline"]),
  granularity_value: PropTypes.oneOfType([PropTypes.number, PropTypes.string, PropTypes.bool]),
  onChangeGranularity: PropTypes.func,
  granularity_options: PropTypes.array,
  granularity_disabled: PropTypes.bool,
  show_dropdown: PropTypes.bool,
  dropdown_value: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  dropdown_disabled: PropTypes.bool,
  dropdown_match_select_width: PropTypes.bool,
  onChangeDropdown: PropTypes.func,
  dropdown_options: PropTypes.array,
  show_first_button: PropTypes.bool,
  first_button_text: PropTypes.string,
  first_button_loading: PropTypes.bool,
  first_button_class: PropTypes.string,
  first_button_type: PropTypes.string,
  onClickFirstButton: PropTypes.func,
  show_second_button: PropTypes.bool,
  second_button_text: PropTypes.string,
  second_button_loading: PropTypes.bool,
  second_button_class: PropTypes.string,
  second_button_type: PropTypes.string,
  onClickSecondButton: PropTypes.func,
  show_search: PropTypes.bool,
  search_placeholder: PropTypes.string,
  onChangeSearch: PropTypes.func,
  onSearch: PropTypes.func,
  show_switch: PropTypes.bool,
  search_disabled: PropTypes.bool,
  switch_class: PropTypes.string,
  switch_checked: PropTypes.bool,
  switch_disabled: PropTypes.bool,
  switch_text_class: PropTypes.string,
  switch_text: PropTypes.string,
  onChangeSwitch: PropTypes.func,
  show_sync: PropTypes.bool,
  sync_spin: PropTypes.bool,
  onClickSync: PropTypes.func,
};

CustomHeader.defaultProps = {
  title_class: "ori-font-sm ori-r-mrgn-10 ori-l-mrgn-5",
  bottom_bordered: false,
  bottom_border_light: false,
  show_date_range: false,
  date_range_props: {},
  date_range_disabled: false,
  granularity_btn_style: "solid",
  granularity_options: [],
  dropdown_options: [],
  dropdown_match_select_width: false,
  granularity_disabled: false,
  show_granularity: false,
  left_wrapper_class: "ori-flex-row ori-flex-wrap",
  right_wrapper_class: "ori-flex-row ori-flex-wrap",
  granularity_container_class: "ori-radio-button-seperated ori-line-height-24",
  show_first_button: false,
  first_button_loading: false,
  first_button_text: 'Save',
  first_button_class: "ori-font-xs ori-border-radius-20 ori-lr-pad-15",
  show_second_button: false,
  second_button_loading: false,
  second_button_text: 'Cancel',
  second_button_class: "ori-font-xs ori-border-radius-20 ori-lr-pad-15",
  show_search: false,
  search_disabled: false,
  search_placeholder: 'Search',
  show_switch: false,
  switch_disabled: false,
  show_sync: false,
  sync_spin: false,
  dropdown_disabled: false,
};

export default CustomHeader;



// WEBPACK FOOTER //
// ./src/components/customheader/index.js